import { largeTabletMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import { Container as SearchInput } from '@propertypal/web-ui/src/inputs/SearchInput.style';
import styled from 'styled-components';

export const Badge = styled.p`
  display: inline-block;
  padding: 2px 6px;
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.white};
  font-weight: 600;
  font-size: 15px;
  border-radius: 5px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;

  & > div:first-child {
    flex: 1;
  }

  & > div:last-child {
    flex: 0 0 35%;
  }

  @media (${largeTabletMax}) {
    & > div:last-child {
      display: none;
    }
  }
`;

export const SearchWrapper = styled.div`
  border-radius: 5px;
  padding: 10px;
  background-color: ${({ theme }) => theme.backgroundLightest};
  margin: 30px 0;

  ${SearchInput} {
    border: 1px solid ${({ theme }) => theme.keyline};
  }

  @media (${tabletMax}) {
    padding: 5px;
  }
`;

export const EmptyBox = styled.p`
  border-radius: 5px;
  padding: 20px;
  background-color: ${({ theme }) => theme.backgroundLightest};
  margin: 10px 0 30px;
  color: ${({ theme }) => theme.backgroundMid};
  font-size: 20px;
  font-weight: 600;
  height: 94px;
  display: flex;
  align-items: center;
`;

export const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  color: ${({ theme }) => theme.textDark};

  button {
    font-size: 16px;
    color: ${({ theme }) => theme.textDark};

    &:hover {
      color: ${({ theme }) => theme.primary};
    }
  }

  @media (${largeTabletMax}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
    margin-bottom: 30px;
  }
`;

export const SelectedAgents = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin: 15px 0 0;
`;

export const AgentBox = styled.div`
  width: 80px;
  height: 80px;
  position: relative;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;

export const RemoveAgent = styled.button`
  width: 24px;
  height: 24px;
  position: absolute;
  top: -12px;
  right: -12px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.backgroundMid};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FormWrapper = styled.div`
  background-color: ${({ theme }) => theme.backgroundLighter};
  padding: 15px;
  margin: 30px 0 0;
  border-radius: 6px;
`;

export const BottomBar = styled.div`
  display: none;
  padding: 15px;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: ${({ theme }) => theme.background};
  border-top: 1px solid ${({ theme }) => theme.backgroundLight};

  @media (${largeTabletMax}) {
    display: block;
  }
`;
